// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"286e3962","879":"2fd288ed"}[chunkId] + ".chunk.js";
};